"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _reactRouter = require("react-router");

var _config = _interopRequireDefault(require("../../targets/cord_sanofi/config.js"));

var _CourseLoader = _interopRequireDefault(require("../helpers/CourseLoader"));

var _Constants = require("./constants/Constants");

// eslint-disable-next-line import/no-extraneous-dependencies, import/extensions, import/no-unresolved
var defaultTypeRouteMap = {
  about: 'about',
  "default": 'ems',
  applink: 'applink',
  external_website: 'external_website',
  equeo_external_website: 'equeo_external_website',
  media_gallery: 'media_gallery',
  settings: _Constants.SETTINGS_PATH,
  single_video: 'videoplayer'
};
var URL_PREFIX_TOURNAMENT = 'quiz_tournament';
var URL_TOURNAMENT_START = 'quiz_tournament_start';
var URL_TRAINING = 'quiz_training';
var URL_MODE_CHOOSER = 'quiz_mode_chooser';
var _instance = null;
/**
 * This module handles dispatching location changes to the right routes.
 * E.g. it decides whether to open a normal content page or a quiz page.
 */

var NavigationManager = /*#__PURE__*/function () {
  function NavigationManager() {
    (0, _classCallCheck2["default"])(this, NavigationManager);
    this.currentPath = []; // TODO read hash location and init current path

    this.onPathChangeListeners = [];
    this.typeRouteMapping = this.initTypeRouteMapping();
    this.lastPage = '';
    this.lastCourseId = null;
  }

  (0, _createClass2["default"])(NavigationManager, [{
    key: "initTypeRouteMapping",
    value: function initTypeRouteMapping() {
      var targetTypeRouteMap = _config["default"].targetFeatures.reduce(function (acc, val) {
        return (0, _assign["default"])(acc, val.FEATURE_TYPE_ROUTE_MAPPING);
      }, {});

      return (0, _assign["default"])({}, defaultTypeRouteMap, targetTypeRouteMap);
    }
  }, {
    key: "goBack",
    value: function () {
      var _goBack = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.lastCourseId) {
                  this.goTo(this.lastCourseId.id, false);
                }

                _reactRouter.hashHistory.goBack();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function goBack() {
        return _goBack.apply(this, arguments);
      }

      return goBack;
    }()
  }, {
    key: "setCurrentLocation",
    value: function () {
      var _setCurrentLocation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(location) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.lastPage = location;

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setCurrentLocation(_x) {
        return _setCurrentLocation.apply(this, arguments);
      }

      return setCurrentLocation;
    }()
  }, {
    key: "getLastLocation",
    value: function () {
      var _getLastLocation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.lastPage);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getLastLocation() {
        return _getLastLocation.apply(this, arguments);
      }

      return getLastLocation;
    }()
    /**
     * Call this method if you know the id you have belongs to a course.
     * @param courseId
     */

  }, {
    key: "goTo",
    value: function () {
      var _goTo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(courseId) {
        var pushToHistory,
            course,
            path,
            location,
            _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                pushToHistory = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : true;

                if (!(courseId !== this.currentPath[this.currentPath.length - 1])) {
                  _context4.next = 19;
                  break;
                }

                _context4.prev = 2;

                if (this.currentPath.length > 0) {
                  this.lastCourseId = this.currentPath[this.currentPath.length - 1];
                }

                _context4.next = 6;
                return _CourseLoader["default"].getCourse(courseId);

              case 6:
                course = _context4.sent;
                _context4.next = 9;
                return this.getCoursePath(course);

              case 9:
                path = _context4.sent;
                this.currentPath = path;
                location = this.getLocation(path);
                this.notifyOnPathChangeListeners();

                if (pushToHistory) {
                  _reactRouter.hashHistory.push(location);
                }

                _context4.next = 19;
                break;

              case 16:
                _context4.prev = 16;
                _context4.t0 = _context4["catch"](2);
                console.log(_context4.t0);

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 16]]);
      }));

      function goTo(_x2) {
        return _goTo.apply(this, arguments);
      }

      return goTo;
    }()
    /**
     * This goes to the <Home> component which then decides which page to open depending on target config.
     * Defaults to first page of root chapter.
     * @param reloadPage If set to true, the whole web app reloads prior to going to that page.
     */

  }, {
    key: "goHome",
    value: function goHome() {
      var reloadPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.currentPath = [];

      if (reloadPage) {
        _reactRouter.hashHistory.replace('/'); // on iOS sometimes the page is not reloaded with the previous command so just make sure the page is reloaded


        if (window) {
          window.location.reload();
        }
      } else {
        _reactRouter.hashHistory.push('/');
      }
    }
  }, {
    key: "goToQuizHome",
    value: function goToQuizHome() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.currentPath = [];
      var prefix = tournamentMode ? URL_PREFIX_TOURNAMENT : '';

      _reactRouter.hashHistory.push(prefix + '/quiz/');
    }
  }, {
    key: "goToQuizHome",
    value: function goToQuizHome() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.currentPath = [];
      var prefix = tournamentMode ? URL_PREFIX_TOURNAMENT : '';

      _reactRouter.hashHistory.push(prefix + '/quiz/');
    }
  }, {
    key: "goToTournamentStart",
    value: function goToTournamentStart() {
      _reactRouter.hashHistory.push(URL_TOURNAMENT_START);
    }
  }, {
    key: "goToQuizTraining",
    value: function goToQuizTraining() {
      _reactRouter.hashHistory.push(URL_TRAINING);
    }
  }, {
    key: "goToQuizModeChooser",
    value: function goToQuizModeChooser() {
      _reactRouter.hashHistory.push(URL_MODE_CHOOSER);
    }
  }, {
    key: "goToQuizActivation",
    value: function goToQuizActivation() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.currentPath = [];
      var prefix = tournamentMode ? URL_PREFIX_TOURNAMENT : '';

      _reactRouter.hashHistory.push(prefix + '/quiz_activation/');
    }
  }, {
    key: "goToQuizRound",
    value: function goToQuizRound() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.currentPath = [];
      var prefix = tournamentMode ? URL_PREFIX_TOURNAMENT : '';

      _reactRouter.hashHistory.push(prefix + '/quiz_round/');
    }
  }, {
    key: "goToQuizStartNewRound",
    value: function goToQuizStartNewRound() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var prefix = tournamentMode ? URL_PREFIX_TOURNAMENT : '';

      _reactRouter.hashHistory.push(prefix + '/quiz_new_round/');
    }
  }, {
    key: "goToQuizHighscore",
    value: function goToQuizHighscore() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.currentPath = [];
      var prefix = tournamentMode ? URL_PREFIX_TOURNAMENT : '';

      _reactRouter.hashHistory.push(prefix + '/quiz_highscore/');
    }
  }, {
    key: "goToQuizOpponents",
    value: function goToQuizOpponents() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.currentPath = [];
      var prefix = tournamentMode ? URL_PREFIX_TOURNAMENT : '';

      _reactRouter.hashHistory.push(prefix + '/quiz_opponents/');
    }
  }, {
    key: "goToSubjectChooser",
    value: function goToSubjectChooser() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.currentPath = [];
      var prefix = tournamentMode ? URL_PREFIX_TOURNAMENT : '';

      _reactRouter.hashHistory.push(prefix + '/quiz_subjects/');
    }
  }, {
    key: "goToQuizCategories",
    value: function goToQuizCategories() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.currentPath = [];
      var prefix = tournamentMode ? URL_PREFIX_TOURNAMENT : '';

      _reactRouter.hashHistory.push(prefix + '/quiz_categories/');
    }
  }, {
    key: "goToRunningQuiz",
    value: function goToRunningQuiz() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.currentPath = [];
      var prefix = tournamentMode ? URL_PREFIX_TOURNAMENT : '';

      _reactRouter.hashHistory.push(prefix + '/quiz_running/');
    }
  }, {
    key: "goToQuizRoundOverview",
    value: function goToQuizRoundOverview() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.currentPath = [];
      var prefix = tournamentMode ? URL_PREFIX_TOURNAMENT : '';

      _reactRouter.hashHistory.push(prefix + '/quiz_round_overview/');
    }
  }, {
    key: "getLocation",
    value: function getLocation(path) {
      var _this = this;

      var fragment = this.typeRouteMapping["default"];
      console.log('getLocation', path);
      (0, _values["default"])(path).some(function (course) {
        if (course.type === null) {
          throw new Error('something expected is not defined');
        }

        if (_this.typeRouteMapping[course.type]) {
          fragment = _this.typeRouteMapping[course.type];
          return true;
        }

        return course.inheritedTypes.some(function (type) {
          if (_this.typeRouteMapping[type]) {
            fragment = _this.typeRouteMapping[type];
            return true;
          }

          return false;
        });
      });
      return "".concat(fragment, "/").concat(path[path.length - 1].id);
    }
  }, {
    key: "getCoursePath",
    value: function () {
      var _getCoursePath = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(course, oldPath) {
        var path, parent;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                path = oldPath || [course];

                if (!course.parent) {
                  _context5.next = 13;
                  break;
                }

                _context5.prev = 2;
                _context5.next = 5;
                return _CourseLoader["default"].getCourse(course.parent);

              case 5:
                parent = _context5.sent;
                path.unshift(parent);
                return _context5.abrupt("return", this.getCoursePath(parent, path));

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](2);
                return _context5.abrupt("return", _promise["default"].reject(_context5.t0));

              case 13:
                return _context5.abrupt("return", _promise["default"].resolve(path));

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[2, 10]]);
      }));

      function getCoursePath(_x3, _x4) {
        return _getCoursePath.apply(this, arguments);
      }

      return getCoursePath;
    }()
  }, {
    key: "handleLink",
    value: function handleLink(url) {
      var match = url.match(/^#?(.+?):\/\//); // match[0] contains the whole match, match[1] contains only the first capture group

      var protocol = match[1];

      switch (protocol) {
        case 'emscourse':
        case 'emscontent':
          {
            var targetId = url.match(new RegExp(".{".concat(match[0].length, "}(.+?)/")))[1];
            this.goTo(targetId);
            return;
          }
        // case 'http':
        // TODO handle link in app
        // case 'browse':
        // TODO handle link in app (but handle url parsing differently than for http)
        // case 'media':
        // TODO implement

        default:
          console.error("unimplemented link type ".concat(protocol, " in url ").concat(url));
      }
    }
  }, {
    key: "addOnPathChangeListener",
    value: function addOnPathChangeListener(listener) {
      this.onPathChangeListeners.push(listener);
    }
  }, {
    key: "notifyOnPathChangeListeners",
    value: function notifyOnPathChangeListeners() {
      var _this2 = this;

      this.onPathChangeListeners.forEach(function (listener) {
        if (!listener) {
          throw new Error('something expected is not defined');
        }

        listener(_this2.currentPath);
      });
    }
  }], [{
    key: "instance",
    value: function instance() {
      if (!_instance) {
        _instance = new NavigationManager();
      }

      return _instance;
    }
  }, {
    key: "goBack",
    value: function goBack() {
      return NavigationManager.instance().goBack();
    }
  }, {
    key: "setCurrentLocation",
    value: function setCurrentLocation(location) {
      return NavigationManager.instance().setCurrentLocation(location);
    }
  }, {
    key: "getLastLocation",
    value: function getLastLocation() {
      return NavigationManager.instance().getLastLocation();
    }
  }, {
    key: "goTo",
    value: function () {
      var _goTo2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(courseId) {
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", NavigationManager.instance().goTo(courseId, true));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function goTo(_x5) {
        return _goTo2.apply(this, arguments);
      }

      return goTo;
    }()
  }, {
    key: "goHome",
    value: function goHome() {
      var reloadPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      NavigationManager.instance().goHome(reloadPage);
    }
  }, {
    key: "goToQuizHome",
    value: function goToQuizHome() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      console.log('gotoquizhome');
      NavigationManager.instance().goToQuizHome(tournamentMode);
    }
  }, {
    key: "goToQuiz",
    value: function goToQuiz() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      NavigationManager.instance().goToQuizHome(tournamentMode);
    }
  }, {
    key: "goToTournamentStart",
    value: function goToTournamentStart() {
      NavigationManager.instance().goToTournamentStart();
    }
  }, {
    key: "goToQuizTraining",
    value: function goToQuizTraining() {
      NavigationManager.instance().goToQuizTraining();
    }
  }, {
    key: "goToQuizModeChooser",
    value: function goToQuizModeChooser() {
      NavigationManager.instance().goToQuizModeChooser();
    }
  }, {
    key: "goToQuizActivation",
    value: function goToQuizActivation() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      NavigationManager.instance().goToQuizActivation(tournamentMode);
    }
  }, {
    key: "goToQuizRound",
    value: function goToQuizRound() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      NavigationManager.instance().goToQuizRound(tournamentMode);
    }
  }, {
    key: "goToQuizStartNewRound",
    value: function goToQuizStartNewRound() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      NavigationManager.instance().goToQuizStartNewRound(tournamentMode);
    }
  }, {
    key: "goToQuizHighscore",
    value: function goToQuizHighscore() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      NavigationManager.instance().goToQuizHighscore(tournamentMode);
    }
  }, {
    key: "goToQuizOpponents",
    value: function goToQuizOpponents() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      NavigationManager.instance().goToQuizOpponents(tournamentMode);
    }
  }, {
    key: "goToSubjectChooser",
    value: function goToSubjectChooser() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      console.log('goToSubjectChooser');
      NavigationManager.instance().goToSubjectChooser(tournamentMode);
    }
  }, {
    key: "goToQuizCategories",
    value: function goToQuizCategories() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      NavigationManager.instance().goToQuizCategories(tournamentMode);
    }
  }, {
    key: "goToRunningQuiz",
    value: function goToRunningQuiz() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      NavigationManager.instance().goToRunningQuiz(tournamentMode);
    }
  }, {
    key: "goToQuizRoundOverview",
    value: function goToQuizRoundOverview() {
      var tournamentMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      NavigationManager.instance().goToQuizRoundOverview(tournamentMode);
    }
  }, {
    key: "handleLink",
    value: function handleLink(url) {
      NavigationManager.instance().handleLink(url);
    }
  }, {
    key: "addOnPathChangeListener",
    value: function addOnPathChangeListener(listener) {
      NavigationManager.instance().addOnPathChangeListener(listener);
    }
  }]);
  return NavigationManager;
}();

var _default = NavigationManager;
exports["default"] = _default;